import { useImperativeHandle, useState } from 'react'

import { DraggableModal } from '../DraggableModal'

import { PreviewFileProps, PreviewItem } from './interface'

export const PreviewVideo = ({ ref }: PreviewFileProps) => {
  const [file, setFile] = useState<PreviewItem>()

  useImperativeHandle(ref, () => {
    return {
      open(file) {
        setFile(file)
      }
    }
  })

  return (
    <DraggableModal
      centered
      destroyOnHidden
      footer={null}
      open={!!file}
      title={file?.name}
      width='90%'
      mask={{
        closable: false
      }}
      onCancel={() => setFile(undefined)}
    >
      <video autoPlay controls muted src={file?.url} width='100%'>
        <track kind='captions' />
      </video>
    </DraggableModal>
  )
}
